
export enum WorkOrderType {
  Project = 1,
  Contract = 2,
  Job = 3
}
